import React from 'react';
import { Typography } from '@material-ui/core';
import clsx from 'clsx';

import { ThreeDotsIcon } from 'ui/icons';

import { IconTileProps } from './IconTile.types';
import { useStyles } from './IconTile.styles';

export const IconTile = ({
  icon,
  title,
  color,
  onClick,
  backgroundColor,
  iconFullSize,
  titleClassName,
}: IconTileProps) => {
  const classes = useStyles({ color, backgroundColor });

  return (
    <div className={classes.container} onClick={onClick}>
      <div className={clsx(classes.icon, iconFullSize && classes.iconFullSize)}>{icon}</div>
      <Typography className={clsx(classes.title, titleClassName)}>{title}</Typography>
      <ThreeDotsIcon color="inherit" className={classes.dotsIcon} />
    </div>
  );
};
